/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { List as MUIList } from '@mui/material';
import { ListItem } from './ListItem';
import { useStyles } from './List.styles';
export function List(props) {
    const classes = useStyles();
    return (React.createElement(MUIList, { className: classes.root, id: props.id }, React.Children.map(props.children, (item, index) => (React.createElement(ListItem, { id: props.id ? `${props.id}_${index}` : undefined, item: item, divider: props.divider, listItemIndex: index, selected: props.includeSelected && props.selectedIndex === index, onClick: props.onClick })))));
}
//# sourceMappingURL=List.js.map